import Contact from "@components/CovidReadyCompliance/Contact";
import Hero from "@components/CovidReadyCompliance/Hero";
import Media from "@components/CovidReadyCompliance/Media";
import Price from "@components/CovidReadyCompliance/Price";
import TestimonialSlider from "@components/TestimonialSlider";
import {NextPage} from "next";
import {useTranslation} from "ni18n";
import React from "react";
import Faq from "src/components/v5/Faq/Faq";
import Layout from "src/components/v5/Layout";

import {NavTheme} from "../../components/v5/Nav/useNavState";
import useCovidReadyComplianceConstants from "../../constants/CovidReadyComplianceConstants";

const Compliance: NextPage = () => {
  const i18n = useTranslation();

  const {defaultTestimons, faq} = useCovidReadyComplianceConstants();

  const pageTitle = i18n.t("Carbon Health | Vaccine compliance tracking");
  const pageDescription = i18n.t(
    "Be OSHA compliant, ensure employee safety and navigate the new COVID-19 vaccine and testing mandates in partnership with a team of HIPAA compliant medical experts.",
  );
  return (
    <Layout
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      pageImage="covidready-compliance"
      navTheme={NavTheme.BLACK}
    >
      <Hero />
      <Price />
      <Media />
      <TestimonialSlider {...{defaultTestimons}} autoRotate />
      <Contact />
      <Faq faq={faq} />
    </Layout>
  );
};

export default Compliance;
